export default __webpack_public_path__ + "mark_5.mp4";